<template>
  <transition name="fade">
    <Popup v-if="showPopup" :close="close" :is-show="showPopup">
      <slot>
        <h2 class="popup__title">
          {{ $i18n.locale === "en" ? "Professional vocabularies" : "Vakvocabulaires" }}
        </h2>
        <div class="popup__subtext">
          <ul>
            <li
              v-for="(parent, index) in breadcrumbs"
              :key="parent.id"
              :class="{ current: index <= breadcrumbs.length - 1, parent: index < breadcrumbs.length - 1 }"
              @click="loadVocabulary(parent)"
            >
              <label>
                {{ parent.translation[$i18n.locale] }}
                <span v-if="index === breadcrumbs.length - 1">({{ parent.frequency }})</span>
              </label>
            </li>
          </ul>
          <ul class="children">
            <li
              v-for="vocabulary in vocabularies"
              :key="vocabulary.id"
              class="child"
              @click="loadVocabulary(vocabulary)"
            >
              <label :for="vocabulary.id">
                {{ vocabulary.translation[$i18n.locale] }}
                ({{ vocabulary.frequency }})
              </label>
            </li>
          </ul>
        </div>
        <div>
          <div class="buttons">
            <v-btn v-if="breadcrumbs.length > 1" elevation="0" class="bg-yellow w-100" @click="onApply">
              {{ $i18n.locale === "en" ? "Search in " : "Zoeken in " }}
              ‘<span class="button-text">{{ breadcrumbs[breadcrumbs.length - 1].translation[$i18n.locale] }}</span
              >’
            </v-btn>
            <v-btn outlined elevation="0" class="w-100" @click="close">{{
              $i18n.locale === "en" ? "Close" : "Sluiten"
            }}</v-btn>
          </div>
        </div>
      </slot>
    </Popup>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import Popup from "~/components/Popup";

export default {
  name: "VocabulariesPopup",
  components: {
    Popup,
  },
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: () => {},
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      path: [],
    };
  },
  computed: {
    ...mapGetters(["vocabularies", "breadcrumbs", "selected_filters"]),
  },
  methods: {
    loadVocabulary(vocabulary) {
      this.$store.dispatch("getVocabulary", vocabulary);
    },
    onApply() {
      const selected_vocabulary = [this.breadcrumbs[this.breadcrumbs.length - 1]?.value];
      this.$emit("apply", selected_vocabulary);
      this.close();
    },
  },
};
</script>
<style scoped lang="less">
@import "./../../variables";

ul {
  padding: 0;
}

li {
  list-style: none;
}

li:hover {
  color: @green;
}

label {
  cursor: pointer;
  display: block;
}

.popup__title {
  font-size: 24px;
}
.popup__subtext {
  overflow-y: none;
}

.w-100 {
  width: 100%;
}
.buttons .v-btn {
  text-transform: none;
  border-radius: 6px;
  font-weight: 700;
  padding: 0 24px;
}

.button-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
}

.buttons {
  display: grid;
  row-gap: 10px;
}

.hasNoDocuments {
  cursor: none;
  pointer-events: none;
}

.current {
  display: flex;
  color: @black;
  font-weight: 700;
  cursor: none;
  pointer-events: none;
}
.current:before {
  margin-right: 10px;
  content: url("../../assets/images/parent-black.svg");
}
.parent {
  display: flex;
  color: @dark-grey;
  font-weight: 700;
  cursor: pointer !important;
  pointer-events: all;
}
li:hover {
  color: @green;
  cursor: pointer !important;
}
.parent:before {
  content: url("../../assets/images/parent.svg");
  margin-right: 10px;
}

.children {
  overflow-y: auto;
  max-height: 38vh;
  padding-top: 20px;
}
.child {
  border-left: 1px solid lightgray;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: normal;
}

.child:after {
  content: "›";
  color: rgb(var(--v-theme-gray-light));
  font-size: 24px;
}

.child:hover {
  color: @green;
}
</style>
